import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "../api/baseurl";
import { toast } from "react-toastify";
import { Modal, Button } from "react-bootstrap";
import "react-toastify/dist/ReactToastify.css";
import "./Spinner.css";
import "./hm-theme.css";

const CreateTestsForPackage = ({ isOpen, onRequestClose, test }) => {
  const date = new Date();
  let day = date.getDate().toString().padStart(2, "0");
  let month = (date.getMonth() + 1).toString().padStart(2, "0");
  let year = date.getFullYear();
  let currentDate = `${year}-${month}-${day}`;
  const navigate = useNavigate();

  const [admin, setAdmin] = useState({
    testname: "",
    description: "",
    categoryid: "",
    labMandatory: false,
    testCost: {
      cost: 0,
      date: currentDate
    }
  });
  const [loading, setLoading] = useState(false);
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = JSON.parse(localStorage.getItem("data")).token;
        const cat = await axios.get(`/api/testcategory/status=true`, {
          headers: { Authorization: `Bearer ${token}` },
        });
        setCategories(cat.data || []);
      } catch {
        toast.error("Failed to fetch test categories.");
      }
    };
    fetchData();
  }, []);

  useEffect(() => {
    if (test) {
      setAdmin({
        testname: test.testname || "",
        description: test.description || "",
        categoryid: test.categoryid || "",
        labMandatory: test.labMandatory === true,
      });
    } else {
      setAdmin({
        testname: "",
        description: "",
        categoryid: "",
        labMandatory: false,
        testCost: {
          cost: 0,
          date: currentDate
        }
      });
    }
  }, [test, currentDate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const token = JSON.parse(localStorage.getItem("data")).token;
    if (admin.testname && admin.categoryid) {
      try {
        const requestBody = { ...admin };
        if (test) {
          requestBody.id = test.id;
          await axios.post(`/api/labtest/update`, requestBody, {
            headers: { Authorization: `Bearer ${token}` },
          });
          toast.success("Test updated successfully");
        } else {
          await axios.post(`/api/labtest/create`, requestBody, {
            headers: { Authorization: `Bearer ${token}` },
          });
          toast.success("Test created successfully");
        }
        onRequestClose();
      } catch (error) {
        handleError(error);
      } finally {
        setLoading(false);
      }
    } else {
      setLoading(false);
      toast.error("Please fill out all required fields.");
    }
  };

  function handleError(error) {
    if (error.response?.status === 401) {
      navigate(`/signin`);
      toast.error("Your session has expired. Please login.");
    } else {
      toast.error(error.response?.data?.message || error.message || "An error occurred.");
    }
  }

  function rhandle(e) {
    const { id, value } = e.target;
    setAdmin((prevState) => ({
      ...prevState,
      [id]: value,
    }));
  }

  function handleCostChange(e) {
    const { value } = e.target;
    setAdmin((prevState) => ({
      ...prevState,
      testCost: {
        ...prevState.testCost,
        cost: parseFloat(value) || 0
      }
    }));
  }

  return (
    <Modal show={isOpen} onHide={onRequestClose} centered>
      <Modal.Header closeButton className="hm-card-header">
        <Modal.Title className="hm-card-title">
          <i className="material-icons">biotech</i>
          {test ? "Update Diagnostic Test" : "Add Diagnostic Test"}
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="p-4">
        {loading && <div className="loading"></div>}
        <form onSubmit={handleSubmit}>
          <div className="mb-3">
            <label htmlFor="categoryid" className="form-label small fw-semibold">
              Category <span className="text-danger">*</span>
            </label>
            <select
              className="form-select"
              id="categoryid"
              value={admin.categoryid}
              onChange={rhandle}
              required
            >
              <option value="">Select Category</option>
              {categories.map((cat) => (
                <option key={cat.id} value={cat.id}>
                  {cat.categoryname}
                </option>
              ))}
            </select>
          </div>

          <div className="mb-3">
            <label htmlFor="testname" className="form-label small fw-semibold">
              Test Name <span className="text-danger">*</span>
            </label>
            <input
              className="form-control"
              id="testname"
              type="text"
              placeholder="e.g. Complete Blood Count (CBC)"
              value={admin.testname}
              onChange={rhandle}
              required
            />
          </div>

          <div className="mb-3">
            <label htmlFor="description" className="form-label small fw-semibold">
              Description
            </label>
            <textarea
              className="form-control"
              id="description"
              placeholder="Test description or instructions..."
              value={admin.description}
              onChange={rhandle}
              rows="2"
            />
          </div>

          {!test && (
            <div className="mb-4">
              <label htmlFor="cost" className="form-label small fw-semibold">
                Cost (₹) <span className="text-danger">*</span>
              </label>
              <input
                className="form-control"
                id="cost"
                type="number"
                step="0.01"
                min="0"
                placeholder="0.00"
                value={admin.testCost?.cost || 0}
                onChange={handleCostChange}
                required={!test}
              />
            </div>
          )}

          <div className="mb-4">
            <label className="form-label small fw-semibold d-block">Lab Mandatory</label>
            <div className="d-flex align-items-center gap-3">
              <div
                className="position-relative"
                style={{ width: "48px", height: "26px", cursor: "pointer" }}
                onClick={() =>
                  setAdmin((prev) => ({ ...prev, labMandatory: !prev.labMandatory }))
                }
              >
                <div
                  style={{
                    width: "48px",
                    height: "26px",
                    borderRadius: "13px",
                    background: admin.labMandatory ? "#2f3a88" : "#dee2e6",
                    transition: "background 0.25s",
                    position: "relative",
                  }}
                >
                  <div
                    style={{
                      width: "20px",
                      height: "20px",
                      borderRadius: "50%",
                      background: "#fff",
                      position: "absolute",
                      top: "3px",
                      left: admin.labMandatory ? "25px" : "3px",
                      transition: "left 0.25s",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.3)",
                    }}
                  />
                </div>
              </div>
              <span className={`small fw-semibold ${admin.labMandatory ? "text-danger" : "text-muted"}`}>
                {admin.labMandatory ? "Yes – Lab visit required" : "No – Home collection allowed"}
              </span>
            </div>
            <p className="text-muted" style={{ fontSize: "0.75rem", marginTop: "6px" }}>
              If enabled, home collection will not be available when booking appointments for packages containing this test.
            </p>
          </div>

          <div className="d-flex justify-content-end gap-2 mt-4">
            <Button variant="secondary" className="rounded-pill px-4" onClick={onRequestClose} disabled={loading}>
              Cancel
            </Button>
            <button type="submit" className="btn-hm-primary" disabled={loading}>
              <i className="material-icons" style={{ fontSize: "1rem" }}>save</i>
              {test ? "Update Test" : "Save Test"}
            </button>
          </div>
        </form>
      </Modal.Body>
    </Modal>
  );
};

export default CreateTestsForPackage;